module.exports = __webpack_public_path__ + "img/user06.790d8465.jpg";